import { Star } from 'assets/icons';
import EmployeeAvatar from 'components/assign/EmployeeAvatar';
import Badge from 'components/badge/badge';
import useText from 'hooks/useText';

// A contact who recommends Jobbiz around them.
export const AmbassadorBadge = () => {
  const { text } = useText('record');
  return (
    <Badge type="AMBER">
      <Star wh={12} color="currentColor" />
      {text('ambassador')}
    </Badge>
  );
};

/**
 * A person of a record: the avatar of their name, their name and badges,
 * then what they are (`detail`: their position, their access, their phone,
 * their e-mail). The row opens their page (`onOpen`); `actions` sit on its
 * right (invite, resend an invitation).
 */
const ContactRow = ({ person, detail, size = 40, onOpen, actions }) => {
  const { text } = useText('record');
  const name = [person.firstname, person.lastname].filter(Boolean).join(' ');
  return (
    <div className="flex items-center gap-2 border-b border-gray-100 last:border-0">
      <button
        type="button"
        disabled={!onOpen}
        onClick={onOpen}
        className="-ml-2 flex min-w-0 flex-1 items-center gap-3 rounded-lg px-2 py-2.5 text-left transition-colors enabled:hover:bg-gray-50"
      >
        <EmployeeAvatar employee={person} size={size} />
        <span className="min-w-0">
          <span className="flex items-center gap-2">
            <span className="truncate text-sm font-medium text-gray-900">{name}</span>
            {person.leadStatus === 'ambassadeur' && <AmbassadorBadge />}
            {person.account === 'pending' && <Badge type="WARNING">{text('pending')}</Badge>}
          </span>
          {detail && <span className="block truncate text-xs text-gray-600">{detail}</span>}
        </span>
      </button>
      {actions}
    </div>
  );
};

export default ContactRow;
